import type { WatchlistItem } from '@/hooks/useWatchlist';

type Props = {
  watchlistItem: WatchlistItem;
};

export const getWatchlistNarrativeFairValue = ({ watchlistItem }: Props) => ({
  fairValue: watchlistItem.company.myValuation?.fairValue ?? null,
  valuationId: watchlistItem.company.myValuation?.id ?? null,
  narrativeId: watchlistItem.company.myValuation?.narrative?.id,
  type: watchlistItem.company.myValuation?.type ?? null,
});
